import { Leaf, ArrowUp, Star, MapPin, Phone, Mail, Clock, PenLine } from "lucide-react";
import { GOOGLE_REVIEWS_URL, GOOGLE_WRITE_REVIEW_URL, GOOGLE_RATING, GOOGLE_REVIEWS_COUNT, PHONE_DISPLAY, PHONE_TEL, ADDRESS } from "@/constants/site";

export const ArtisanFooter = () => {
  return (
    <footer data-testid="footer" className="bg-[#121F17] text-[#F5F3EE] relative rb-grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[#F5F3EE]/10">
          <div className="md:col-span-5">
            <a href="#top" data-testid="footer-logo" className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-full bg-[#2D5A3F] flex items-center justify-center">
                <Leaf className="w-5 h-5 text-[#F5F3EE]" strokeWidth={1.8} />
              </span>
              <span className="font-serif-rb text-2xl">RB <span className="italic text-[#8CA893]">Espace Vert</span></span>
            </a>
            <p className="mt-6 text-[#F5F3EE]/60 text-sm leading-relaxed max-w-sm">
              Élagueurs-grimpeurs avec le soin du détail, jardiniers-paysagistes et arboristes —
              nous maîtrisons tout ce qui touche à l'espace vert.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <a
                href={GOOGLE_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-google-badge"
                className="inline-flex items-center gap-2 text-xs text-[#F5F3EE]/70 border border-[#F5F3EE]/15 rounded-full px-4 py-2 hover:border-[#D4AF37]/60 hover:text-[#D4AF37] transition-colors duration-300"
              >
                <Star className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" />
                Noté {GOOGLE_RATING} / 5 — {GOOGLE_REVIEWS_COUNT} avis Google
              </a>
              <a
                href={GOOGLE_WRITE_REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-leave-review"
                className="inline-flex items-center gap-1.5 text-xs text-[#D4AF37]/80 hover:text-[#D4AF37] transition-colors duration-300"
              >
                <PenLine className="w-3.5 h-3.5" /> Laisser un avis
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-rb text-xs uppercase tracking-[0.25em] text-[#8CA893] mb-6">Expertises</p>
            <ul className="space-y-3 text-sm text-[#F5F3EE]/70">
              <li>Élagage &amp; abattage</li>
              <li>Jardinage paysager</li>
              <li>Taille de haies</li>
              <li>Arboriculture &amp; diagnostic</li>
              <li>Entretien d'espaces verts</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-rb text-xs uppercase tracking-[0.25em] text-[#8CA893] mb-6">Contact</p>
            <ul className="space-y-4 text-sm text-[#F5F3EE]/70">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#D4AF37] shrink-0" />
                <a href={PHONE_TEL} data-testid="footer-phone" className="hover:text-[#F5F3EE] transition-colors">{PHONE_DISPLAY}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#D4AF37] shrink-0" />
                <a href="mailto:contact@rb-espace-vert.fr" data-testid="footer-email" className="hover:text-[#F5F3EE] transition-colors">contact@rb-espace-vert.fr</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" />
                <span data-testid="footer-zone">
                  {ADDRESS}<br />
                  <span className="text-[#F5F3EE]/50">Interventions : Montreuil, Paris Est &amp; environs</span>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#D4AF37] shrink-0" />
                <span data-testid="footer-hours">Ouvert jusqu'à 19h — Devis sous 24h</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-14 overflow-hidden">
          <p className="font-serif-rb text-[13vw] md:text-[9vw] leading-none text-center whitespace-nowrap text-[#F5F3EE]/[0.06] select-none">
            RB Espace Vert
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-[#F5F3EE]/10 text-xs text-[#F5F3EE]/40">
          <p>© {new Date().getFullYear()} RB Espace Vert — Montreuil (93100) — Tous droits réservés</p>
          <p>Mentions légales · Devis gratuit</p>
          <a
            href="#top"
            data-testid="footer-back-to-top"
            className="flex items-center gap-2 hover:text-[#D4AF37] transition-colors duration-300"
          >
            Retour en haut <ArrowUp className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </footer>
  );
};
